<template>
  <svg
    :class="{ VvLogo: true, 'VvLogo--auto': auto, 'VvLogo--text': text }"
    style="isolation: isolate"
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath :id="`a${logoId}`">
        <path d="M0 0h59.92v114.377H0z" />
      </clipPath>
    </defs>
    <g
      :clip-path="`url(#a${logoId})`"
      transform="matrix(1.7486 0 0 1.7486 47.612 0)"
    >
      <linearGradient
        :id="`b${logoId}`"
        x1=".5"
        y1="0"
        x2=".5"
        y2="1"
        gradientTransform="scale(59.92 97.21)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="2.083%" stop-color="#ffd54f" />
        <stop offset="98.333%" stop-color="#ff6f00" />
      </linearGradient>
      <path
        d="M0 68.6v-40c0-2.6 1.1-5.08 3.02-6.84l10.74-9.82L24.5 2.11c.01-.01.03-.02.04-.04A8.144 8.144 0 0129.96 0c2 0 3.93.74 5.42 2.07.01.02.03.03.04.04l10.75 9.83 10.74 9.82a9.276 9.276 0 013.01 6.84v40c0 2.6-1.09 5.09-3.01 6.84l-10.74 9.83-10.75 9.82c-.01.02-.03.03-.04.04a8.104 8.104 0 01-10.84 0c-.01-.01-.03-.02-.04-.04l-10.74-9.82-10.74-9.83A9.269 9.269 0 010 68.6z"
        :fill="`url(#b${logoId})`"
      />
      <linearGradient
        :id="`c${logoId}`"
        x1=".5"
        y1="0"
        x2=".5"
        y2="1"
        gradientTransform="matrix(29.96 0 0 97.21 29.96 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stop-color="#ff6f00" />
        <stop offset="98.333%" stop-color="#ffd54f" />
      </linearGradient>
      <path
        d="M59.92 28.6v40c0 2.6-1.09 5.09-3.01 6.84l-10.74 9.83-10.75 9.82c-.01.02-.03.03-.04.04a8.104 8.104 0 01-5.42 2.08V0c2 0 3.93.74 5.42 2.07.01.02.03.03.04.04l10.75 9.83 10.74 9.82a9.276 9.276 0 013.01 6.84z"
        :fill="`url(#c${logoId})`"
      />
      <path
        d="M59.92 65.576L34.704 88.7a818.173 818.173 0 01-2.262 22.582c-.11.92-.58 1.76-1.31 2.34-.72.58-1.65.84-2.57.73a3.45 3.45 0 01-2.34-1.3c-.58-.72-.84-1.65-.74-2.57.86-7.48 1.61-14.97 2.25-22.47.47-5.43.82-10.87 1.06-16.32.09-1.89.16-3.79.21-5.69.04-1.64.07-3.29.08-4.94 0-.93.38-1.81 1.04-2.47.66-.65 1.55-1.01 2.48-1.01.93.01 1.82.38 2.47 1.04a3.53 3.53 0 01.984 2.056L59.92 38.795v4.069L36.029 64.765a377.032 377.032 0 01-.25 7.526L59.92 50.147v4.069L35.562 76.553a418.856 418.856 0 01-.506 7.752l24.864-22.8z"
        fill="#37474f"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface Props {
  logoId: string;
  auto?: boolean;
  text?: boolean;
}

const props = withDefaults(defineProps<Props>(), {});
</script>

<style lang="scss">
.VvLogo {
  width: 200px;
  height: 200px;

  &--text {
    width: 1em;
    height: 1em;
  }

  &--auto {
    height: 100%;
    width: auto;
  }
}
</style>
